export default {
  LeftMenu: {
    Control: 'Control',
    EmployeeList: 'Nhân viên',
    CollapseText: 'Thu gọn',
    InventoryItem: 'Kho',
    Account: 'Tài khoản',
    Dashboard: 'Tổng quan',
    Treasury: 'Kho bạc',
    Etreasury: 'Kho bạc điện tử',
    CA: 'Tiền mặt',
    BA: 'Tiền gửi',
    SU: 'Công cụ dụng cụ',
    FA: 'Tài sản cố định',
    Salary: 'Tiền lương',
    PU: 'Mua hàng',
    SA: 'Bán hàng',
    Invoice: 'Hóa đơn',
    Tax: 'Thuế',
    GL: 'Tổng hợp',
    Report: 'Báo cáo',
    Knowledge: 'Kiến thức hữu ích',
    ConnectASP: 'Kết nối chuyên gia',
    Dictionary: 'Danh mục',
    AccountBalance: 'Số dư ban đầu',
    OpeningSupplyEntry: 'CCDC ban đầu',
  },
  LeftMenuTooltip: {
    AccountBalance: 'Nhập số dư ban đầu',
    OpeningSupplyEntry: 'Nhập số dư Công cụ dụng cụ ban đầu',
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },
};
